import React, { useEffect, useState } from 'react';
import { getFunFacts, rotateFunFacts } from '../services/funFactsService';
import WaitGlass from './WaitGlass.jsx';
import '../styles/searchStates.css';

const WAITING_LINES = [
    'Scanning the live universe...',
    'Checking what\'s on air right now...',
    'Matching live events to your search...',
    'Following the signal...',
    'Gathering what\'s live worldwide...',
    'Finding streams that fit this search...',
    'Curating what\'s happening now...',
    'Lining up live channels...',
    'Almost there, sorting the live feed...',
    'One more moment while we lock the results...',
];

const shuffle = (list) => {
    const copy = [...list];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};

/**
 * SearchWaitingState Component
 *
 * Displays an enhanced waiting state with spinner, rotating copy, and optional fun facts.
 *
 * @param {Object} props
 * @param {string} props.query - The search query being processed
 * @param {number} props.elapsedTime - Time elapsed since search started (in seconds)
 */
const SearchWaitingState = ({ query, elapsedTime = 0 }) => {
    const [lines] = useState(() => shuffle(WAITING_LINES));
    const [funFacts, setFunFacts] = useState([]);
    const [currentFact, setCurrentFact] = useState(null);

    const currentMessage = lines[Math.floor(elapsedTime / 3) % lines.length];

    useEffect(() => {
        const loadFunFacts = async () => {
            try {
                const facts = await getFunFacts(query);
                setFunFacts(facts);

                if (facts.length > 0) {
                    setCurrentFact(facts[0]);
                }
            } catch (error) {
                console.warn('Could not load fun facts:', error);
            }
        };

        loadFunFacts();
    }, [query]);

    useEffect(() => {
        if (funFacts.length > 1) {
            const cleanup = rotateFunFacts(funFacts, 5000, (fact) => {
                setCurrentFact(fact);
            });
            return cleanup;
        }
    }, [funFacts]);

    return (
        <div className="search-waiting-state">
            <div className="search-waiting-rings" aria-hidden="true">
                <WaitGlass />
            </div>
            <div className="search-waiting-content">
                <div className="search-waiting-message">
                    <p key={currentMessage} className="waiting-message-text">{currentMessage}</p>
                </div>

                {currentFact && (
                    <div className="search-fun-fact-container">
                        <div className="fun-fact-label">Did you know?</div>
                        <div className="fun-fact-text">{currentFact}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchWaitingState;
